import SalesSlipForm from './SalesSlipForm';

export default SalesSlipForm;
